import classnames from 'classnames'
import React, {FC, useCallback, useEffect, useMemo, useState} from 'react'
import { FooterLogo } from '../footer-logo/FooterLogo'
import { PhotoGrid } from '../photo-grid/PhotoGrid'
import { useStateValue } from '../state-provider/StateProvider'
import './Content.css'
import { log } from '../../utils/log'

import {
  setIsLoading,
  setIsWidgetMaximized,
  setUserEmail,
  setGridAreaContent,
  navigateCard, setUserActivation,
} from '../app/App.action'
import {EventInteractionType, ws} from '../../events/ws'
import { isEmpty } from 'lodash'
import { sendToWidget } from "../../utils/postMessages";
import { GridAreaContent } from "./GridAreaContent";
import { ShareBoost } from "./ShareBoost";
import { ScheduledLivestreamBanner } from './components/ScheduledLivestreamBanner'
import { HeaderTitle } from './components/HeaderTitle'
import { BackButton } from './components/BackButton'
import {useHistory} from "react-router-dom";
import {SequencePollControls} from "./components/SequencePollControls";
import {useShare} from "../../hooks/useShare";
import {ChatContainer2} from '../chat/ChatContainer2'
import {ChatSettingsForm} from "../chat/ChatSettingsForm";
import {VideoPlayer} from "./components/VideoPlayer";
import {formatTime} from "../../utils/utils";
import './components/LivestreamIndicator.css'
import {BrandFollowForm2} from "./BrandFollowForm2";
import {ReminderForm} from "./ReminderForm";
import {TopBar} from "../top-bar/TopBar";


export type HeaderType = 'Video' | 'Image' | 'LiveStream'

const Content: FC<{

}> = ({

}) => {
  const [
    {
      cardUuid,
      header,
      liveStream,
      liveChat,
      sequencePollUuid,
      parentCardId,
      widgetLocation,
      brand,
      isSessionEstablished,
      isFullScreenExpanded,
      shareUrl,
      gridAreaContent,
      translations,
    },
    dispatch,
  ] = useStateValue()

  let history = useHistory()

  const [livestreamSeekTime, setLivestreamSeekTime] = useState(0)

  const goBack = useCallback(() => {
    dispatch(setIsLoading({ isLoading: false }))
    // @ts-ignore
    dispatch(navigateCard(parentCardId, history, "User"))
  }, [dispatch, parentCardId, history])


  const handleMessage = useCallback((event: MessageEvent) => {
    if (event?.data?.type === "user-activation") {
      log("User activation")
      dispatch(setUserActivation({ userActivation: true }))
    }
    if (event?.data?.type === 'widget-closed') {
      ws.sendEvent(EventInteractionType.WIDGET_CLOSED)
    }
    if (event?.data?.type === 'widget-minimized') {
      ws.sendEvent(EventInteractionType.WIDGET_MINIMIZED)
      dispatch(
        setIsWidgetMaximized({
          isWidgetMaximized: false,
        }),
      )
    }
    if (event?.data?.type === 'widget-maximized') {
      ws.sendEvent(EventInteractionType.WIDGET_MAXIMIZED)
      dispatch(
        setIsWidgetMaximized({
          isWidgetMaximized: true,
        }),
      )
    }
    if (event?.data?.type === 'widget-state') {

      let state = event?.data?.value?.state
      dispatch(setUserEmail({ userEmail: state?.userEmail }))
    }
  }, [ws, dispatch, setUserEmail, setIsWidgetMaximized])

  useEffect(() => {
    window.addEventListener('message', handleMessage, true)
    return () => {
      window.removeEventListener('message', handleMessage, true)
    }
  }, [handleMessage])

  useEffect(() => {
    sendToWidget(
      {
        type: 'has-video-res',
        value: {
          status: false //!!(header?.liveStreamUrl || header?.videoUrl),
        }
      },
    )
  }, [header])

  // hardcoded value for possibility to control highlighting from contester panel
  const allowHighlight = false


  const headerType = useMemo<HeaderType>(() => {
    let h: HeaderType
    if (header?.liveStreamUrl) {
      h = 'LiveStream'
    } else if (header?.videoUrl) {
      h = 'Video'
    } else {
      h = 'Image'
    }

    return h
  }, [header])

  useEffect(() => {
    if (!header?.liveStreamUrl || !liveStream?.connectedAt) return
    const connectedAtMs = parseInt(liveStream.connectedAt) * 1000
    const interval = setInterval(() => {
      const elapsed = (Date.now() - connectedAtMs) / 1000
      if (elapsed > 0) {
        setLivestreamSeekTime(elapsed)
      }
    }, 1000)
    return () => clearInterval(interval)
  }, [header?.liveStreamUrl, liveStream?.connectedAt])

  const { handleShare } = useShare({ shareUrl, widgetLocation })

  return (
    <>
      <TopBar/>
      <div
        className={classnames('content', {
          'has-title': Boolean(header?.title),
          'has-image': headerType === 'Image',
        })}
      >
        <div className={classnames(
          'photo-container',
          isFullScreenExpanded ? 'fullscreen' : '',
          )}
        >
          <header
            // onContextMenu={e => e.preventDefault()}
            className={classnames(
              header === null ? 'hide' : 'show',
            )}
          >
            { liveStream && !Boolean(header?.liveStreamUrl) && (
              <ScheduledLivestreamBanner />
            )}
            { (headerType === 'LiveStream' || headerType === 'Video') && (
              <VideoPlayer
                liveStreamUrl={header?.liveStreamUrl}
                onDemandUrl={header?.videoUrl}
              />
            )}
            { headerType === 'Image' && (
              <img alt="Poster" src={header?.imageUrl || undefined} />
            )}
            <SequencePollControls
              currentLiveStreamUrl={header?.liveStreamUrl}
              liveStreamConnected={Boolean(header?.liveStreamUrl)}
              livestreamSeekTime={livestreamSeekTime}
            />
            {Boolean(header?.liveStreamUrl) && (
              <div className={classnames("livestream-indicator")}>
                <div className="duration">{formatTime(livestreamSeekTime)}</div>
                <div className="live-dot"></div>
                <div className="live-label">
                  {translations['LiveStreamIndicatorLabel'] || "LIVE"}
                </div>
              </div>
            )}
            <HeaderTitle />
          </header>
          <div className="carousel-nav">
            <div className="spacer-y" />
            {
              <BackButton
                  onClick={goBack}
                  disabled={!cardUuid || !parentCardId}
                  isHighlighted={allowHighlight && cardUuid}
                  animate={allowHighlight && cardUuid}
              />
            }
          </div>
          <div className={classnames('right-section-container',{'hidden': gridAreaContent === 'Grid'})}>
            <div className={classnames("carousel-nav-mobile", { hidden: !parentCardId })}>
              <BackButton
                onClick={goBack}
                disabled={!cardUuid || !parentCardId}
                isHighlighted={allowHighlight && cardUuid}
                animate={allowHighlight && cardUuid}
                variant="mobile"
              />
            </div>
            {!isEmpty(liveChat) && isSessionEstablished && sequencePollUuid && (
              <>
                <GridAreaContent
                  requiredGridAreaContent={'LiveChat'}
                  content={<ChatContainer2
                    organizationId={liveChat.organizationId}
                    experienceId={sequencePollUuid}
                    referenceId={liveChat.referenceId}

                  />}
                />
                <GridAreaContent
                  requiredGridAreaContent={'LiveChatSettings'}
                  openAreaUponClose={'LiveChat'}
                  content={<ChatSettingsForm
                    organizationId={liveChat.organizationId}
                    experienceId={sequencePollUuid}
                    referenceId={liveChat.referenceId}
                  />}
                />
              </>
            )}
            {!isEmpty(liveStream) && isSessionEstablished && (
              <GridAreaContent
                requiredGridAreaContent={'LiveStreamReminderForm'}
                content={<ReminderForm />}
              />
            )}
            {isSessionEstablished && brand && (
              <GridAreaContent
                requiredGridAreaContent={'BrandFollowForm'}
                content={<BrandFollowForm2 />}
              />
            )}
            <GridAreaContent
              requiredGridAreaContent={'ShareBoost'}
              content={<ShareBoost shareButtonClicked={() => {
                  handleShare()
                  dispatch(setGridAreaContent('Grid'))
                }}
              />}
            />
            <PhotoGrid
              isReminderFormVisible={gridAreaContent === 'LiveStreamReminderForm'}
              isLiveChatVisible={gridAreaContent === 'LiveChat'}
            />
          </div>
        </div>

        <FooterLogo />
      </div>
    </>
  )
}

export default Content
